//@ts-nocheck
import React from 'react';
import { AppTextField } from '../inputs';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../types';

export const BillingCityField: React.FC<FieldProps> = ({ margin }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      rules={{
        required: 'City is required',
      }}
      control={control}
      name="address.city"
      render={({ field }) => (
        <AppTextField
          label="City"
          margin={margin}
          fullWidth
          {...field}
          error={!!errors?.address?.city?.message}
          helperText={errors?.address?.city?.message || ''}
        />
      )}
    />
  );
};
